import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class ClientStyleService {

	constructor(@Inject(DOCUMENT) private document: Document, private http: HttpClient) { }

	public loadDefaultStyles(){
		this.applyClientTheme('no-client');
	}

	public loadClientBranding(clientKey: string){
		return new Promise<string>((resolve, reject) => {
			let key = '';
			this.applyClientTheme('no-client');
			if(clientKey != null){
				this.applyClientTheme(clientKey);
				localStorage.setItem("clientKey", clientKey);
			} else {
				key = localStorage.getItem("clientKey");
				if(key != null){
					this.applyClientTheme(key);
				}
			}
			resolve(key);
		});
	}

	// public loadClientBranding2(clientKey: string){
	// 	this.applyClientTheme('no-client');
	// 	if(clientKey != null){
	// 		this.applyClientTheme(clientKey);
	// 		localStorage.setItem("clientKey", clientKey);
	// 	}else{
	// 		let key = localStorage.getItem("clientKey");
	// 		if(key != null){
	// 			this.applyClientTheme(key);
	// 		}
	// 	}
	// }

	private applyClientTheme(clientKey: string){
		var themeCssUrl: string = '/' + clientKey + '.css';
		const headerEl = this.document.getElementsByTagName('head')[0];

		const exsistingLink = this.document.getElementById('client-theme') as HTMLLinkElement;
		if (exsistingLink){
			exsistingLink.href = themeCssUrl;
		}else{
			const newLinkEl = this.document.createElement('link');
			newLinkEl.id = 'client-theme';
			newLinkEl.rel = 'stylesheet';
			newLinkEl.href = themeCssUrl;
			headerEl.appendChild(newLinkEl);
		}
		this.http.get(themeCssUrl, { observe: 'response', responseType: 'text' }).subscribe((resp: any) => {
			if(resp != null) {
				console.log('THEME ' + themeCssUrl + ' LOADED');
			} else {
				console.log('Could not load client stylesheet - unavailable.');
			}
		}, (error: any) => {
			console.log(error);
		});
	}
}
